import { render, staticRenderFns } from "./PriceEstimation.vue?vue&type=template&id=4f435ea4&"
import script from "./PriceEstimation.vue?vue&type=script&lang=js&"
export * from "./PriceEstimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports